// Pomodoro Timer Translations
// Supports: German (de), Italian (it), French (fr), Spanish (es)

export const POMODORO_TRANSLATIONS = {
  de: {
    // Mode labels
    focus: 'Fokus',
    short_break: 'Kurze Pause',
    long_break: 'Lange Pause',
    
    // Button labels
    start: 'Start',
    pause: 'Pause',
    resume: 'Weiter',
    reset: 'Reset',
    stop: 'Stop',
    
    // Duration labels
    duration: 'Dauer',
    minutes: 'Min',
    
    // Stats labels
    today: 'Heute',
    focus_sessions: 'Fokus-Sessions',
    study_time: 'Lernzeit',
    this_session: 'Diese Sitzung',
    statistics: 'Statistiken',
    this_week: 'Diese Woche',
    total: 'Gesamt',
    
    // Subject
    subject: 'Fach',
    general: 'Allgemein',
    
    // Info
    timer_running_info: 'Timer läuft auch wenn du andere Seiten öffnest ✓',
    timer_paused_info: 'Timer pausiert – läuft weiter wenn du zurückkommst',
    
    // Pomodoro technique info
    technique_title: 'Pomodoro-Technik',
    technique_focus: '25 Min fokussiert lernen',
    technique_short: '5 Min kurze Pause',
    technique_long: 'Nach 4 Sessions: 15 Min Pause',
    technique_streak: 'Zählt für deinen Streak!',
    
    // Toast messages
    toast_focus_complete: 'Fokus-Session abgeschlossen! Zeit für eine Pause. 🍅',
    toast_short_break_complete: 'Pause vorbei – wieder konzentrieren! 💪',
    toast_long_break_complete: 'Lange Pause beendet – du schaffst das! 🔥',
  },
  
  it: {
    // Mode labels
    focus: 'Focus',
    short_break: 'Pausa breve',
    long_break: 'Pausa lunga',
    
    // Button labels
    start: 'Avvia',
    pause: 'Pausa',
    resume: 'Riprendi',
    reset: 'Reset',
    stop: 'Stop',
    
    // Duration labels
    duration: 'Durata',
    minutes: 'Min',
    
    // Stats labels
    today: 'Oggi',
    focus_sessions: 'Sessioni di focus',
    study_time: 'Tempo di studio',
    this_session: 'Questa sessione',
    statistics: 'Statistiche',
    this_week: 'Questa settimana',
    total: 'Totale',
    
    // Subject
    subject: 'Materia',
    general: 'Generale',
    
    // Info
    timer_running_info: 'Il timer continua anche se cambi pagina ✓',
    timer_paused_info: 'Timer in pausa – riprenderà quando torni',
    
    // Pomodoro technique info
    technique_title: 'Tecnica Pomodoro',
    technique_focus: '25 min di studio concentrato',
    technique_short: '5 min di pausa breve',
    technique_long: 'Dopo 4 sessioni: 15 min di pausa',
    technique_streak: 'Conta per la tua serie!',
    
    // Toast messages
    toast_focus_complete: 'Sessione di focus completata! È ora di una pausa. 🍅',
    toast_short_break_complete: 'Pausa finita – torniamo a concentrarci! 💪',
    toast_long_break_complete: 'Pausa lunga terminata – ce la puoi fare! 🔥',
  },
  
  fr: {
    // Mode labels
    focus: 'Focus',
    short_break: 'Pause courte',
    long_break: 'Pause longue',
    
    // Button labels
    start: 'Démarrer',
    pause: 'Pause',
    resume: 'Reprendre',
    reset: 'Réinitialiser',
    stop: 'Arrêter',
    
    // Duration labels
    duration: 'Durée',
    minutes: 'Min',
    
    // Stats labels
    today: "Aujourd'hui",
    focus_sessions: 'Sessions de focus',
    study_time: "Temps d'étude",
    this_session: 'Cette session',
    statistics: 'Statistiques',
    this_week: 'Cette semaine',
    total: 'Total',
    
    // Subject
    subject: 'Matière',
    general: 'Général',
    
    // Info
    timer_running_info: 'Le timer continue même si tu changes de page ✓',
    timer_paused_info: 'Timer en pause – reprendra quand tu reviendras',
    
    // Pomodoro technique info
    technique_title: 'Technique Pomodoro',
    technique_focus: '25 min de concentration',
    technique_short: '5 min de pause courte',
    technique_long: 'Après 4 sessions : 15 min de pause',
    technique_streak: 'Compte pour ta série !',
    
    // Toast messages
    toast_focus_complete: 'Session de focus terminée ! C\'est l\'heure de la pause. 🍅',
    toast_short_break_complete: 'Pause terminée – on se reconcentre ! 💪',
    toast_long_break_complete: 'Longue pause terminée – tu vas y arriver ! 🔥',
  },
  
  es: {
    // Mode labels
    focus: 'Enfoque',
    short_break: 'Pausa corta',
    long_break: 'Pausa larga',
    
    // Button labels
    start: 'Iniciar',
    pause: 'Pausar',
    resume: 'Continuar',
    reset: 'Reiniciar',
    stop: 'Detener',
    
    // Duration labels
    duration: 'Duración',
    minutes: 'Min',
    
    // Stats labels
    today: 'Hoy',
    focus_sessions: 'Sesiones de enfoque',
    study_time: 'Tiempo de estudio',
    this_session: 'Esta sesión',
    statistics: 'Estadísticas',
    this_week: 'Esta semana',
    total: 'Total',
    
    // Subject
    subject: 'Materia',
    general: 'General',
    
    // Info
    timer_running_info: 'El temporizador sigue aunque cambies de página ✓',
    timer_paused_info: 'Temporizador en pausa – continuará cuando vuelvas',
    
    // Pomodoro technique info
    technique_title: 'Técnica Pomodoro',
    technique_focus: '25 min de estudio concentrado',
    technique_short: '5 min de pausa corta',
    technique_long: 'Después de 4 sesiones: 15 min de pausa',
    technique_streak: '¡Cuenta para tu racha!',
    
    // Toast messages
    toast_focus_complete: '¡Sesión de enfoque completada! Es hora de un descanso. 🍅',
    toast_short_break_complete: '¡Pausa terminada – volvamos a concentrarnos! 💪',
    toast_long_break_complete: '¡Pausa larga terminada – tú puedes! 🔥',
  },
};

// Helper function to get translation
export const getTranslation = (lang, key) => {
  const translations = POMODORO_TRANSLATIONS[lang] || POMODORO_TRANSLATIONS.de;
  return translations[key] || POMODORO_TRANSLATIONS.de[key] || key;
};

// Helper hook for pomodoro translations
export const usePomodoroTranslations = (lang = 'de') => {
  const t = (key) => getTranslation(lang, key);
  return { t, lang };
};
